export enum CloseTableReason {
  UNKNOWN = 0,
  NIGHT_LIMIT_KICK = 8,
}
